﻿import axios from 'axios'
import { getLeadAttributions } from './lead-attributions'

const LEAD_TYPES = {
  ApplyClick: 'ApplyClick',
  WebsiteClick: 'WebsiteClick'
}

const createLead = (leadType, listingId ) => {
  const url = `${rentler.apiBaseUri}/leads`
  const attributions = getLeadAttributions()
  const data = { listingId: listingId, leadType: leadType, leadAttributions: attributions }
  return axios.post(url, data)
}

export {
  createLead,
  LEAD_TYPES
}